/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

type Props = {
  className?: string;
};
const StyledSVG = styled.svg`
  .cls-1 {
    fill: ${(props) => props.theme.palette.common.white};
  }
  height: 100%;
`;

const SVG = ({ className }: Props) => (
  <StyledSVG
    id='Ebene_1'
    data-name='Ebene 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 70 63.88'
    className={className}
  >
    <g id='Page-1'>
      <g id='TLK' data-name='TLK'>
        <path
          id='Fill-1'
          className='cls-1'
          d='M9.05.12h2.33A9.59,9.59,0,0,1,21,9.71L21,37.18c0,1.5.06,7.13.81,9a8.39,8.39,0,0,0,5.1,4.93V64c-6.7-.4-12.45-5-15.34-11.57a28.21,28.21,0,0,1-2.19-9.74,10.13,10.13,0,0,0-.56-2.5A9.63,9.63,0,0,0,0,34.45V21.65a19.39,19.39,0,0,1,9.1,2.27l0-23.8Zm20.1,0h2.33a9.59,9.59,0,0,1,9.59,9.59l.06,27.47c0,1.5.06,7.13.8,9A8.41,8.41,0,0,0,47,51.08V64c-6.7-.4-12.45-5-15.34-11.57-2-4.34-2.18-8.92-2.45-14-.05-.8-.1-38.32-.1-38.32Zm20.36,0h2.32a9.59,9.59,0,0,1,9.6,9.59l0,13.63a13.53,13.53,0,0,1,6.88-1.89,20.16,20.16,0,0,1,2.46.11V34.21l-1.08,0c-4.45,0-8.06,2.66-8.06,8.63,0,6.24,4.71,8.62,8.06,8.62h1.35l0,12.46c-.59.07-2.17.1-2.78.1-7.07,0-13.2-4.66-16.25-11.49-2-4.45-2.22-9-2.49-14.07,0-.8-.1-38.32-.1-38.32Z'
          transform='translate(0 -0.12)'
        />
      </g>
    </g>
  </StyledSVG>
);

export default styled(SVG)`` as any;
export const TlkGrey: any = styled(SVG)`
  .cls-1 {
    fill: ${(props) => props.theme.palette.primary.contrastTextDisabled};
  }
`;
